/**
 * Act2SceneSelect — 第二幕场景选择
 */
import React from 'react';
import { Coffee, Utensils, TreePine, Film } from 'lucide-react';
import { useAct2Store } from '../../stores/act2Store';
import { useRootStore } from '../../stores/rootStore';

const SCENES = [
  { id: '咖啡厅', icon: Coffee, label: '咖啡厅', desc: '安静优雅，适合深度交谈' },
  { id: '餐厅', icon: Utensils, label: '餐厅', desc: '美食助兴，气氛轻松' },
  { id: '公园', icon: TreePine, label: '公园散步', desc: '自然放松，适合慢慢了解' },
  { id: '电影院', icon: Film, label: '电影院', desc: '共同体验，话题丰富' },
];

export const Act2SceneSelect: React.FC = () => {
  const act2 = useAct2Store();
  const root = useRootStore();

  const handleSelect = (sceneId: string) => {
    act2.setScene(sceneId);
    root.startAct2();
  };

  return (
    <div className="h-screen flex flex-col items-center justify-center p-6 bg-gradient-to-b from-cream to-[#F5EDE3]">
      <div className="max-w-md w-full">
        <h2 className="text-xl font-bold text-center text-[#2D2D2D] mb-2">选择约会地点</h2>
        <p className="text-sm text-[#9CA3AF] text-center mb-6">
          {root.protagonistA?.name} 和 {root.protagonistB?.name} 的二人世界即将开始
        </p>

        <div className="grid grid-cols-2 gap-3">
          {SCENES.map(scene => {
            const Icon = scene.icon;
            return (
              <button
                key={scene.id}
                onClick={() => handleSelect(scene.id)}
                className="flex flex-col items-center gap-2 p-4 bg-white rounded-xl border-2 border-[#E5E0D8] hover:border-coral-300 hover:shadow-lg transition-all active:scale-95"
              >
                <Icon size={28} className="text-coral-500" />
                <span className="text-sm font-bold text-[#2D2D2D]">{scene.label}</span>
                <span className="text-[10px] text-[#9CA3AF] text-center">{scene.desc}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Act2SceneSelect;
